<template>
  <div>
    <v-container>
      <template>
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            width="960"
            @click:outside="closeModal"
            :retain-focus="false"
          >
            <v-card class="custom-card" rounded="0">
              <v-toolbar color="secondary" class="white--text">
                <v-toolbar-title class="font-weight-bold">
                  Subgroup Animal Details
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-row class="align-center">
                  <v-col cols="9">
                    <v-tabs class="tabs-pill my-5" v-model="tab">
                      <v-tab
                        class="text-capitalize"
                        v-for="subGroup in subGroups"
                        :key="subGroup.id"
                        @click="changeTab(subGroup)"
                        >{{ subGroup.subGroupName }}</v-tab
                      >
                    </v-tabs>
                  </v-col>
                  <v-col cols="3">
                    <div class="d-flex justify-end">
                      <div class="py-3">
                        {{ tableOptions.page }} of {{ totalPages }}
                      </div>
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        :disabled="tableOptions.page <= 1"
                        @click="pageChange(false)"
                      >
                        <v-icon dark> mdi-chevron-left </v-icon>
                      </v-btn>
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        :disabled="tableOptions.page >= totalPages"
                        @click="pageChange(true)"
                      >
                        <v-icon dark> mdi-chevron-right </v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-tabs-items v-model="tab">
                  <v-tab-item v-for="subGroup in subGroups" :key="subGroup.id">
                    <v-data-table
                      :headers="headers"
                      :items="subGroupAnimals"
                      :items-per-page="10"
                      :loading="loading"
                      loading-text="Loading Ingredients Selection... Please wait"
                      hide-default-footer
                      :header-props="{
                        'sort-icon': 'mdi-unfold-more-horizontal',
                      }"
                    >
                      <template v-slot:item.gender="{ item }">
                        <td class="text-capitalize">{{ item.animalGender }}</td>
                      </template>
                      <template v-slot:item.breed="{ item }">
                        <td class="text-capitalize">{{ item.breed || 0 }}</td>
                      </template>
                      <template v-slot:item.dateOfBirth="{ item }">
                        <td class="text-capitalize">
                          {{ item?.dateOfBirth }}
                        </td>
                      </template>
                      <template v-slot:item.regDate="{ item }">
                        <td class="text-capitalize">
                          {{ item?.regDate }}
                        </td>
                      </template>
                      <template v-slot:item.status="{ item }">
                        <td class="capitlize text-center">
                          <v-btn
                            x-small
                            rounded
                            min-width="120"
                            color="green2"
                            depressed
                            class="primary--text border-active"
                            height="34"
                          >
                            {{ item.animalStatus }}
                          </v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import { getAnimalsByRationGeneratedSubGroupId } from "@/graphql/Feed.gql";
export default {
  // apollo: {
  //   getAnimalsByRationGeneratedSubGroupId: {
  //     query: getAnimalsByRationGeneratedSubGroupId,
  //     update: (data) => data.getAnimalsByRationGeneratedSubGroupId.rows,
  //     fetchPolicy: "no-cache",
  //     variables() {
  //       return {
  //         subGroupAnimalInput: {
  //           rationAnimalGeneratedSubgroupId:
  //             this.rationAnimalGeneratedSubGroupId,
  //           page: this.tableOptions.page,
  //           limit: this.tableOptions.limit,
  //         },
  //       };
  //     },
  //     result({ data }) {
  //       this.subGroupAnimals = data.getAnimalsByRationGeneratedSubGroupId.rows;
  //       this.totalPages = data.getAnimalsByRationGeneratedSubGroupId.totalPages;
  //       this.loading = false;
  //     },
  //   },
  // },
  data() {
    return {
      loading: false,
      totalPages: 0,
      search: "",
      pageCount: 1,
      tableOptions: { page: 1, limit: 5 },
      tab: null,
      headers: [
        {
          text: "ID",
          value: "animalID",
          class: "black--text",
          sortable: false,
        },
        {
          text: "TAG#",
          value: "animalTag",
          class: "black--text",
          sortable: false,
        },
        {
          text: "Date Of Birth",
          value: "dateOfBirth",
          class: "black--text",
          sortable: false,
        },
        {
          text: "Gender",
          value: "animalGender",
          class: "black--text",
          sortable: false,
        },
        {
          text: "Breed",
          value: "breed",
          class: "black--text",
          sortable: false,
        },
        {
          text: "Reg. Date",
          value: "regDate",
          class: "black--text",
          sortable: false,
        },
        {
          text: "STATUS",
          sortable: false,
          align: "center",
          value: "animalStatus",
          class: "black--text",
        },
      ],

      items: [
        {
          id: "DM00082",
          tag: "#RED2871HD",
          dateOfBirth: "22 / 05 / 2019",
          gender: "male",
          breed: "mix breed",
          regOfDate: "24 / 07 / 2021",
          status: "On The Farm",
        },
        {
          id: "DM00082",
          tag: "#RED2871HD",
          dateOfBirth: "22 / 05 / 2019",
          gender: "male",
          breed: "mix breed",
          regOfDate: "24 / 07 / 2021",
          status: "On The Farm",
        },
        {
          id: "DM00082",
          tag: "#RED2871HD",
          dateOfBirth: "22 / 05 / 2019",
          gender: "male",
          breed: "mix breed",
          regOfDate: "24 / 07 / 2021",
          status: "On The Farm",
        },
        {
          id: "DM00082",
          tag: "#RED2871HD",
          dateOfBirth: "22 / 05 / 2019",
          gender: "male",
          breed: "mix breed",
          regOfDate: "24 / 07 / 2021",
          status: "On The Farm",
        },
        {
          id: "DM00082",
          tag: "#RED2871HD",
          dateOfBirth: "22 / 05 / 2019",
          gender: "male",
          breed: "mix breed",
          regOfDate: "24 / 07 / 2021",
          status: "On The Farm",
        },
        {
          id: "DM00082",
          tag: "#RED2871HD",
          dateOfBirth: "22 / 05 / 2019",
          gender: "male",
          breed: "mix breed",
          regOfDate: "24 / 07 / 2021",
          status: "On The Farm",
        },
      ],
      subGroupAnimals: [],
      localRationAnimalGeneratedSubGroupId:
        this.rationAnimalGeneratedSubGroupId,
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  mounted() {
    this.loading = true;
    this.tab = this.subGroups.findIndex(
      (obj) => obj.id == this.rationAnimalGeneratedSubGroupId
    );
    this.updateTable();
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    subGroups: {
      type: Array,
      required: true,
    },
    rationAnimalGeneratedSubGroupId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },

    createGroupModal() {
      this.$emit("createGroupName");
    },

    getAnimalList() {
      return this.$apollo
        .query({
          query: getAnimalsByRationGeneratedSubGroupId,
          variables: {
            subGroupAnimalInput: {
              rationAnimalGeneratedSubgroupId:
                this.localRationAnimalGeneratedSubGroupId,
              page: this.tableOptions.page,
              limit: this.tableOptions.limit,
            },
          },
        })
        .then((data) => {
          this.subGroupAnimals = data;
          this.closeModal();
        })
        .catch((e) => Promise.reject(e));
    },

    pageChange(t) {
      if (t) this.tableOptions.page = Number(this.tableOptions.page) + 1;
      else this.tableOptions.page = Number(this.tableOptions.page) - 1;

      this.$router.replace({ query: { page: this.tableOptions.page } });
    },

    changeTab(item) {
      this.localRationAnimalGeneratedSubGroupId = Number(item.id);
      this.updateTable();
    },

    async updateTable() {
      this.loading = true;
      this.currentSubGroup =
        this.currentSubGroup ?? this.groupDetails?.subGroup[0];
      // const tab = this.tabs[index];
      // if (!tab.contentLoaded) {
      // Make the GraphQL query to fetch the content for the selected tab
      const response = await this.$apollo.query({
        query: getAnimalsByRationGeneratedSubGroupId,
        fetchPolicy: "no-cache",
        variables: {
          subGroupAnimalInput: {
            rationAnimalGeneratedSubgroupId:
              this.localRationAnimalGeneratedSubGroupId,
            page: this.tableOptions.page,
            limit: this.tableOptions.limit,
          },
        },
      });

      console.log(response);

      this.subGroupAnimals =
        response.data.getAnimalsByRationGeneratedSubGroupId.rows;
      this.totalPages =
        response.data.getAnimalsByRationGeneratedSubGroupId.totalPages;
      this.loading = false;

      // this.items = await this.markCheckedData(
      //   response.data.getUserIngredientDetail.rows
      // );
      // this.totalRecords = response.data.getUserIngredientDetail.totalRecords;
      // this.totalPages = response.data.getUserIngredientDetail.totalPages;
      // this.loading = false;
    },
  },
  // watch: {
  //   // whenever question changes, this function will run
  //   rationAnimalGeneratedSubGroupId(val) {
  //     this.getAnimalList(val);
  //   },
  // },
};
</script>

<style lang="scss" scoped>
.border-active {
  border: 1px solid green !important;
}

.border-deactivated {
  border: 1px solid red !important;
}
</style>
